export const columns = ({ t }) => [
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('Code'),
    name: 'externalId'
  }
];

export const mockedRows = [];

export const formatData = items =>
  items.map(item => ({
    id: item.id,
    externalId: item.externalId,
    accessorialServiceId: item.accessorialServiceId,
    name: item.name,
    description: item.description,
    rowVersion: String(item.rowVersion)
  }));

export default {
  columns,
  mockedRows,
  formatData
};
